import React from "react";
import Header from "../Header/Header.tsx";
import Footer from "../Footer/Footer.tsx";
import Amenities from "../Amenities/Amenities.tsx";
import VideoCarouselComponent from "../../Carousel/VideoCarouselComponent.tsx";
import Contact from "../Contact/Contact.tsx";
import About from "../About/About.tsx";
import Gallery from "../Gallery/Gallery.tsx";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import Nearby from "../NearBy/Nearby.tsx";

const Home: React.FC = () => {
  return (
    <>
      <section>
        <Header />
      </section>
      <div>
        <div className="home_outer">
          <div className="overlay">
            <VideoCarouselComponent />
          </div>
          </div>
        

        {/* aminities */}

        <section id="Amenities" >

          <Amenities />
        </section>
        {/* Nearby places */}

        <section id="Nearby">
          <Nearby/>
        </section>

        {/* gallery */}

        <section id="Gallery" style={{paddingTop:"50px"}}>
          <Gallery />
        </section>

        {/* About US */}

        <section id="About">
          <About />
        </section>

        {/* contact */}

        <section id="Contact" style={{width:"100%"}}>
          <Contact />
        </section>
        <a
          href="https://wa.me/8888769628"
          className="whatsapp-link"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none", color: "green" }}
        >
          <WhatsAppIcon
            sx={{
              position: "fixed",
              bottom: "10px",
              right: "20px",
              zIndex: "1111",
              fontSize: 40,
              margin: "5px",
              borderRadius:"20%",
              color: "green",
              "&:hover": {
              color: "white",
              background:"green",
              cursor: "pointer",
              },
            }}
          />
        </a>
        <section>
          <Footer />
        </section>
      </div>
    </>
  );
};
export default Home;
